<template>
  <transition name="slide">
    <div class="site-banner" v-show="show">
      <div class="container-fluid">
        <div class="site-banner__in">
          <div class="site-banner__message">
            <span>{{
                $t('site_banner.message')
              }}</span>
            <a class="site-banner__action" :href="url" @click="hideBanner"
               target="_blank">{{ $t('site_banner.button') }}</a>
          </div>
        </div>
      </div>
      <a href="#" class="site-banner__closer" @click.prevent="hideBanner">
        <img alt="close" :src="require('@/assets/icon-close.svg')">
      </a>
    </div>
  </transition>
</template>


<script>
import {mapGetters} from "vuex";

export default {
  name: 'UseGetPicaForYourEvent',
  data() {
    return {
      show: false
    }
  },
  watch: {
    enabled: {
      handler(newValue) {
        newValue ? this.showBanner() : this.hideBanner()
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters('bannerGetPica', ['settings']),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters(['isPicaThirdLevelDomain']),
    enabled() {
      return (this.settings && this.settings.enabled)
    },
    url() {
      if (!this.settings) return ''
      let locale = this.$i18n.locale === 'it' ? 'it' : 'en'
      return this.settings.url[locale] || this.settings.url
    },
  },

  methods: {
    showBanner() {
      setTimeout(() => this.show = true, 2000)
    },
    hideBanner() {
      this.show = false
    }
  }
}
</script>
